import Plyr from 'plyr'
import { registerLegacySalvoLiteComponent, legacySalvoLiteLog as log } from '@eastsideco/salvo-ts';

class Player {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }
    
    onInit () {

        // Define controls, a list of controls can be found here https://github.com/sampotts/plyr/blob/master/CONTROLS.md
        const controls = [
            'play-large',
            'play',
            'progress',
            'current-time',
            'duration',
            'mute',
            'volume',
            'captions',
            'fullscreen'
        ];

        // Init player
        const player = new Plyr(this._elem, {
            controls: controls
        });
    }
}

export default registerLegacySalvoLiteComponent({
    component: Player,
    selector: '[data-player]', // Required
});
